import React from 'react';
import { SubscriberProgress } from 'types/electionService';
import { colors } from '@insurancemenu/imenu-components-lib';
import {
  InfoButtonFilled,
  RadioButtonChecked,
  CheckCircle,
  RadioButtonUnchecked,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { TagWrapperStyled } from './styles';
import { IMQS_PROGRESS_TAG_TEST_IDS } from '../constants';

interface Props {
  status: SubscriberProgress;
}

const STATUS_TEXT_MAP = Object.freeze({
  [SubscriberProgress.NOT_YET_STARTED]: 'Not Yet Started',
  [SubscriberProgress.IN_PROGRESS]: 'In Progress',
  [SubscriberProgress.COMPLETED]: 'Completed',
  [SubscriberProgress.INCOMPLETE_PROFILE]: 'Incomplete Profile',
  [SubscriberProgress.INCOMPLETE_DEPENDENT]: 'Incomplete Dependent',
  [SubscriberProgress.PARTIALLY_ELECTED]: 'Partially Elected',
  [SubscriberProgress.ELECTION_COMPLETED]: 'Election Completed',
  [SubscriberProgress.ELECTION_PENDING]: 'Election Pending',
  [SubscriberProgress.FINALIZE_ELECTION]: 'Finalize Election',
});

const STATUS_ICON_MAP = Object.freeze({
  [SubscriberProgress.NOT_YET_STARTED]: (
    <InfoButtonFilled
      color={colors.purple[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.INFO_BUTTON_FILLED}
    />
  ),
  [SubscriberProgress.IN_PROGRESS]: (
    <RadioButtonChecked
      color={colors.yellow[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.RADIO_BUTTON_CHECKED}
    />
  ),
  [SubscriberProgress.COMPLETED]: (
    <CheckCircle color={colors.blue[600]} width="2.2rem" data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.CHECK_CIRCLE} />
  ),
  [SubscriberProgress.INCOMPLETE_PROFILE]: (
    <InfoButtonFilled
      color={colors.red[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.INFO_BUTTON_FILLED}
    />
  ),
  [SubscriberProgress.INCOMPLETE_DEPENDENT]: (
    <InfoButtonFilled
      color={colors.red[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.INFO_BUTTON_FILLED}
    />
  ),
  [SubscriberProgress.PARTIALLY_ELECTED]: (
    <RadioButtonChecked
      color={colors.yellow[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.RADIO_BUTTON_CHECKED}
    />
  ),
  [SubscriberProgress.FINALIZE_ELECTION]: (
    <InfoButtonFilled
      color={colors.purple[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.INFO_BUTTON_FILLED}
    />
  ),
  [SubscriberProgress.ELECTION_PENDING]: (
    <RadioButtonUnchecked
      color={colors.blue[600]}
      width="2.2rem"
      data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.INFO_BUTTON_FILLED}
    />
  ),
  [SubscriberProgress.ELECTION_COMPLETED]: (
    <CheckCircle color={colors.blue[600]} width="2.2rem" data-test-id={IMQS_PROGRESS_TAG_TEST_IDS.CHECK_CIRCLE} />
  ),
});

const SubscriberProgressTag: React.FC<Props> = ({ status }) => {
  return (
    <TagWrapperStyled>
      {STATUS_ICON_MAP[status]}
      {STATUS_TEXT_MAP[status]}
    </TagWrapperStyled>
  );
};

export default SubscriberProgressTag;
